/* tslint:disable */
/* eslint-disable */
/**
 * Sunshine Auction API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    AdminWorkerJobProduct,
    AdminWorkerJobProductFromJSON,
    AdminWorkerJobProductFromJSONTyped,
    AdminWorkerJobProductToJSON,
} from './AdminWorkerJobProduct';
import {
    AdminWorkerJobState,
    AdminWorkerJobStateFromJSON,
    AdminWorkerJobStateFromJSONTyped,
    AdminWorkerJobStateToJSON,
} from './AdminWorkerJobState';

/**
 * 
 * @export
 * @interface AdminWorkerJob
 */
export interface AdminWorkerJob {
    /**
     * Args are the job arguments as stored by River, e.g. {"product_id": "..."}.
     * @type {object}
     * @memberof AdminWorkerJob
     */
    args: object;
    /**
     * 
     * @type {number}
     * @memberof AdminWorkerJob
     */
    attempt: number;
    /**
     * 
     * @type {string}
     * @memberof AdminWorkerJob
     */
    attemptedAt?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminWorkerJob
     */
    createdAt: string;
    /**
     * 
     * @type {string}
     * @memberof AdminWorkerJob
     */
    finalizedAt?: string;
    /**
     * 
     * @type {number}
     * @memberof AdminWorkerJob
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof AdminWorkerJob
     */
    kind: string;
    /**
     * 
     * @type {string}
     * @memberof AdminWorkerJob
     */
    lastError?: string;
    /**
     * 
     * @type {number}
     * @memberof AdminWorkerJob
     */
    maxAttempts: number;
    /**
     * Product the job works on, when it works on one (directly or through a listing).
     * @type {AdminWorkerJobProduct}
     * @memberof AdminWorkerJob
     */
    product?: AdminWorkerJobProduct;
    /**
     * 
     * @type {string}
     * @memberof AdminWorkerJob
     */
    queue: string;
    /**
     * 
     * @type {string}
     * @memberof AdminWorkerJob
     */
    scheduledAt: string;
    /**
     * 
     * @type {AdminWorkerJobState}
     * @memberof AdminWorkerJob
     */
    state: AdminWorkerJobState;
}



export function AdminWorkerJobFromJSON(json: any): AdminWorkerJob {
    return AdminWorkerJobFromJSONTyped(json, false);
}

export function AdminWorkerJobFromJSONTyped(json: any, ignoreDiscriminator: boolean): AdminWorkerJob {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'args': json['args'],
        'attempt': json['attempt'],
        'attemptedAt': !exists(json, 'attemptedAt') ? undefined : json['attemptedAt'],
        'createdAt': json['createdAt'],
        'finalizedAt': !exists(json, 'finalizedAt') ? undefined : json['finalizedAt'],
        'id': json['id'],
        'kind': json['kind'],
        'lastError': !exists(json, 'lastError') ? undefined : json['lastError'],
        'maxAttempts': json['maxAttempts'],
        'product': !exists(json, 'product') ? undefined : AdminWorkerJobProductFromJSON(json['product']),
        'queue': json['queue'],
        'scheduledAt': json['scheduledAt'],
        'state': AdminWorkerJobStateFromJSON(json['state']),
    };
}

export function AdminWorkerJobToJSON(value?: AdminWorkerJob | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'args': value.args,
        'attempt': value.attempt,
        'attemptedAt': value.attemptedAt,
        'createdAt': value.createdAt,
        'finalizedAt': value.finalizedAt,
        'id': value.id,
        'kind': value.kind,
        'lastError': value.lastError,
        'maxAttempts': value.maxAttempts,
        'product': AdminWorkerJobProductToJSON(value.product),
        'queue': value.queue,
        'scheduledAt': value.scheduledAt,
        'state': AdminWorkerJobStateToJSON(value.state),
    };
}

